import React from "react"
import TeamItem from "../components/TeamItem"
import { useStaticQuery, graphql } from "gatsby"

function Team() {
  const { allTeamYaml } = useStaticQuery(graphql`
    {
      allTeamYaml {
        edges {
          node {
            name
            img
            show
            user
          }
        }
      }
    }
  `)
  return (
    <div id = "team" className="container-fluid" style={{ backgroundColor: "#E1DFD2" }}>
      <div className="container">
        <div className="flexbox">
          <h1 className="text-center my-4">Work </h1>
          <div className="row my-5">
            {allTeamYaml.edges.map(({ node }) => {
              return <TeamItem title={node.name} src={node.img} show={node.show} user={node.user} />
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Team
